import { initDependencies, setupDependencies } from './app';
import { runApp } from './services/runApp';

setupDependencies();

initDependencies();

runApp();

// tslint:disable-next-line:no-any
if ((module as any).hot) {
  // tslint:disable-next-line:no-any
  (module as any).hot.accept();
}
